import { createApp } from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import i18n from './i18n';
import store from '@phoenix/store';

export default (options = {}, useStore = false) => {
  const app = createApp(options);

  app.use(VueObserveVisibility);
  app.use(i18n);

  if (useStore) {
    app.use(store);
  }

  window.Phoenix.sentry.attach(app);

  return app;
};
